import { css } from "@emotion/react";

import { dimensions } from "@styles/index";

export const tileGrid = css`
  width: 100%;
  max-width: ${dimensions.containerMedium};

  @media (max-width: ${dimensions.phoneLargeMax}) {
    flex-direction: column;
  }
`;

export const form = css`
  flex: 1;
  width: 100%;
`;

export const tile = css`
  width: 100%;
`;
